const publicUrl = (
  typeof process !== "undefined" && process.env.PUBLIC_URL
    ? process.env.PUBLIC_URL
    : ""
).replace(/\/$/, "");

export const DATASET_PATH = `${publicUrl}/extensions_data.csv`;

export const APP_COPY = {
  title: "Product Hunt Ecosystem Insights",
  subtitle:
    "A data-driven analysis of product launches, popularity, adoption, quality, categories, and recognition trends",

  datasetLabel: "Product Hunt Dataset (CSV)",

  datasetTooltip:
    "This dashboard analyzes Product Hunt products using launch timelines, follower counts, real user adoption, average ratings, category distribution, and award recognition to uncover market trends and product performance insights.",
};

export const DATASET_FIELDS_LIMIT = 80;
